import { Target } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#090B0D]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 lg:grid-cols-[1fr_auto] lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center border border-clay/50 bg-clay/10 text-clay"><Target className="h-5 w-5" /></span>
            <span className="font-display text-3xl">TODO<span className="text-clay">tiro</span> <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">al plato</span></span>
          </div>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-slate-400">
            Archivo vivo de tiradas, carteles, resultados, fotografías de premiados y crónicas de foso universal, Trap 5 y foso olímpico. Preparado para enlazar Flickr, compartir en redes y crecer con el contenido histórico del club.
          </p>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.22em] text-slate-500">
          <p>Temporada 2026</p>
          <p className="mt-3 text-clay">Precisión · Memoria · Comunidad</p>
        </div>
      </div>
    </footer>
  );
}
